import { BudgetScenarioPartnerLocationOption, BudgetScenarioWorkingUnitOption } from '@callmart/types';
import api from './index';

const BASE = '/budget-scenarios';

export interface ScenarioShiftRampValue {
    month: string; // 'YYYY-MM-DD'
    sharePct: number; // absolute percent of the Von location's volume shifted this month
}

// CALL-783: the client clarified that a Verschiebung moves the volume of ONE working unit
// (worktype – channel – task) from one location to another, so a row's identity is the working unit and
// not the worktype it belongs to — the board's own table names it ("o2 Care - Inbound Voice - Alle").
// `availableWorktypes` is therefore gone from this response: a worktype spans several working units and
// could not say which one is being retrained. `share` is gone from the row for a different reason — it
// was informational, no calc ever read it, and the ramp already carries the percent really shifted.
export interface ScenarioShiftRow {
    id: number;
    workingUnitId: number;
    /** Carried per row, not looked up in the options: a rebased scenario may point at a working unit that
     *  has left the bucket, and such a row must still read as a name. */
    workingUnitLabel: string;
    fromLocationId: number;
    toLocationId: number;
    agents: number;
    /** Training days per agent — the COST multiplier, and only prefilled from the Start/Ende window. */
    trainingDays: number;
    costPerHour: number;
    trainerCost: number;
    trainingStart: string | null; // 'YYYY-MM-DD' or null
    /** The ENTERED end of the training window (CALL-783) — the window the training cost is spread over.
     *  null = the backend walks `trainingDays` weekdays from the start, as it did before the field. */
    trainingEnd: string | null;
    ramp: ScenarioShiftRampValue[];
}

export interface ScenarioShiftRowsResponse {
    /** The scenario's `updatedAt` AS OF this read — the revision the form's next PATCH must send with THESE
     *  rows (see ScenarioContactValuesResponse.revision for why the scenario query cannot supply it). */
    revision: string;
    rows: ScenarioShiftRow[];
    availablePartnerLocations: BudgetScenarioPartnerLocationOption[];
    availableWorkingUnits: BudgetScenarioWorkingUnitOption[];
}

/** `versionId` is the version the OPTION lists must describe — the DRAFT one while the detail form's
 *  Budget select is pointed elsewhere, so the pickers stay in step with the impact preview (which is
 *  already priced against that version). Omitted, the server answers from the scenario's stored one. */
export const getScenarioShiftRows = async (
    scenarioId: number,
    versionId?: number
): Promise<ScenarioShiftRowsResponse> => {
    return api.get(`${BASE}/${scenarioId}/shift-rows`, { params: { versionId } }).then((res) => res.data);
};
